// theme/index.js
import { extendTheme } from '@chakra-ui/react';

// Global style overrides
import styles from './styles';

// Foundational style overrides
import colors from './foundation/colors';
import breakpoints from './foundation/breakpoints';
import borderRadius from './foundation/borderradius';

// Component style overrides
import Button from './components/button';
import Link from './components/link';
import Modal from './components/modal';
import {menuTheme} from './components/menu';

const overrides = {
  styles,
  colors,
  breakpoints,
  borderRadius,
  fonts: {
    heading: `'Poppins', sans-serif`,
    body: `'Inter', sans-serif`,
  },
  
  
  // Other foundational style overrides go here
  components: {
    Button,
    Link,
    Modal,
    Menu: menuTheme,
    // Other components go here
  },
};

export default extendTheme(overrides);
